/* Copyright 2016 VMware, Inc. All rights reserved. -- VMware Confidential */

namespace network_ui {

   export class VmMigrateSelectVmsPageValidator
         implements VmMigrateWizardPageValidator {

      public static $inject = [
            "i18nService",
            "$q",
            "vmMigrateWizardConstants"];

      constructor(private i18nService: any,
                  private $q: any,
                  private wizardConstants: any) {
      }

      public getValidationError(wizardScope: VmMigrateWizardScope): string[] {
         let errors: string[] = [];

         if (!this.hasSelectedItem(wizardScope.model.treeListItemData)) {
            errors.push(this.i18nService.getString(
                  "NetworkUi", "SelectVmsToMigratePage.noAdaptersSelected"));
         }

         return this.$q.resolve(errors);
      }

      private hasSelectedItem(treeListItemData: any[]): boolean {
         if (!treeListItemData) {
            return false;
         }

         for (let item of treeListItemData) {
            if (item.isChecked && item.id !== this.wizardConstants.ALL_VMS_ITEM_ID) {
               return true;
            }
         }
         return false;
      }
   }

   angular.module("com.vmware.vsphere.client.network")
         .service("vmMigrateSelectVmsPageValidator",
               VmMigrateSelectVmsPageValidator);
}
